var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:_vm.computedClass,style:({ backgroundColor: _vm.colorComputed })},[_c('ul',{staticClass:"va-topbar__menu"},[_vm._t("menu")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }